import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../lib/motion";
import { SOFTWARE_IMAGES } from "../lib/data";
import { TechnicalImage } from "./TechnicalImage";

export const Software = () => (
  <section id="softwareentwicklung" data-testid="software-section" className="relative py-20 md:py-28 lg:py-36 bg-brand-surface border-y border-white/5">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-8 lg:gap-16 items-end">
        <Reveal className="lg:col-span-7 min-w-0">
          <p className="section-eyebrow"><span /> Softwareentwicklung</p>
          <h2 className="section-heading">Kennfelder verstehen.<br /><span className="text-brand">Nicht nur verändern.</span></h2>
        </Reveal>
        <Reveal className="lg:col-span-5 min-w-0" delay={0.08}>
          <p className="text-white/60 leading-relaxed">
            Eine passende Abstimmung beginnt mit der Analyse. Wir arbeiten mit WinOLS,
            untersuchen vorhandene Softwarestände und entwickeln individuelle
            Kalibrierungen. Entscheidend ist, wie die Funktionen im Steuergerät zusammenspielen.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-6 md:gap-10 mt-10 md:mt-14 mb-10">
        {[
          ["01", "Analysieren", "Kennfelder zuordnen, Softwarestände vergleichen und das Drehmomentmodell nachvollziehen."],
          ["02", "Kalibrieren", "Je nach Motor und Steuergerät Ladedruck, Einspritzung, Zündung und Lambda aufeinander abstimmen."],
          ["03", "Prüfen", "Schutzfunktionen berücksichtigen und Änderungen mit Diagnose und Plausibilitätsprüfungen bewerten."],
        ].map(([number, title, text]) => (
          <Reveal key={number}>
            <div className="border-t border-brand/40 pt-5">
              <h3 className="flex items-center gap-3 font-display text-base font-bold"><span className="font-mono text-xs text-brand-light">{number}</span>{title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/55">{text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="software-grid grid md:grid-cols-2 gap-4 lg:gap-6">
        {SOFTWARE_IMAGES.map((item, i) => (
          <Reveal key={item.src} delay={(i % 2) * 0.06} className="min-w-0">
            <TechnicalImage item={item} />
          </Reveal>
        ))}
      </div>
      <Reveal>
        <div className="mt-8 flex flex-col sm:flex-row sm:items-center justify-between gap-5">
          <p className="font-mono text-[11px] leading-relaxed text-white/40">Einblicke in unsere Kennfeldarbeit mit WinOLS. Alle Ansichten sind vergrößerbar.</p>
          <a href="#kontakt" className="inline-flex items-center gap-2 text-sm text-brand-light hover:text-white transition-colors shrink-0">
            Projekt besprechen <ArrowUpRight size={16} />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
